import { Component, Inject, OnInit, inject, NgModule } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LogService } from '../../services/log.service';
import { FormsModule, NgModel } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';


@Component({
  selector: 'app-log-dialog',
  imports: [CommonModule, MatDialogModule, MatTableModule, MatProgressSpinnerModule, FormsModule, MatIconModule, MatButtonModule],
  templateUrl: './log-dialog.component.html',
  styleUrl: './log-dialog.component.scss',
  standalone: true
})
export class LogDialogComponent implements OnInit {
  protected svcLog = inject(LogService);

  dataSource: MatTableDataSource<any>;
  loadedRecords: number=0;
  loading:boolean=true;
  records:number=100;

  displayedColumns: string[] = ["Timestamp", "User", "Action"];

  constructor(
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<LogDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ){}

  ngOnInit(): void {
    this.getLog();
  }

  onNoClick(){
    this.dialog.closeAll();
  }

  getLog(){
    this.svcLog.getLog(this.data.site, this.data.proficy_env, this.data.object_id).subscribe( out=> {
      console.debug("getLog", out)
      this.dataSource = out["Body"];
      this.loadedRecords = out["Body"].length;
      this.loading = false;
    })
  }

}
